var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coupon-list"},_vm._l((_vm.coupons),function(item,index){return _c('div',{key:index,staticClass:"coupon",on:{"click":function($event){return _vm.clickCoupon(item)}}},[_vm._v(_vm._s(item.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }